let swiper;

function initSwiper() {
    const isDesktop = window.innerWidth >= 899;

    if (swiper) {
        swiper.destroy(true, true);
    }

    swiper = new Swiper(".js-testimonial-swiper", {
        spaceBetween: 30,
        loop: true,    
        effect: isDesktop ? "fade" : "slide",
        autoHeight: true,
        fadeEffect: { 
            crossFade: true 
        },
        navigation: {
            nextEl: ".testimonial-swiper-arrows .swiper-button-next",
            prevEl: ".testimonial-swiper-arrows .swiper-button-prev",
        },
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        breakpoints: {
            899: {
                spaceBetween: 0,
                effect: "fade",
                fadeEffect: { 
                    crossFade: true 
                },
                autoHeight: false,
            }
        }
    });
}

initSwiper();

window.addEventListener('resize', () => {
    initSwiper();
});
